const HRDeliverySync = (() => {

  let syncing = false;

  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  function getDeliveryVariant(city) {
    if (!city) return null;

    const handle = window.HRFurnitureShipping?.handles?.[city];
    if (!handle) return null;

    return window.HRFurnitureShipping?.variantIds?.[handle] || null;
  }

  function getProductItems(cart) {
    return cart.items.filter(item => {
      return !Object.values(window.HRFurnitureShipping.variantIds)
        .includes(item.variant_id);
    });
  }

  function getDeliveryItem(cart) {
    return cart.items.find(item => {
      return Object.values(window.HRFurnitureShipping.variantIds)
        .includes(item.variant_id);
    });
  }

 async function addDelivery(variantId, qty) {

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: qty
    })
  });

  if (window.routes && document.querySelector('cart-drawer')) {

    const cart = await fetch(
      `${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`
    ).then(r => r.json());

    document.querySelector('cart-drawer').renderContents({
      id: variantId,
      sections: {
        "cart-drawer": cart["cart-drawer"],
        "cart-icon-bubble": cart["cart-icon-bubble"]
      }
    });
    setTimeout(() => sync(), 150);

  }

}

 async function changeLine(line, qty) {

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      line,
      quantity: qty
    })
  });

  if (window.routes && document.querySelector('cart-drawer')) {

    const cart = await fetch(
      `${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`
    ).then(r => r.json());

    document.querySelector('cart-drawer').renderContents({
      id: line,
      sections: {
        "cart-drawer": cart["cart-drawer"],
        "cart-icon-bubble": cart["cart-icon-bubble"]
      }
    });
    setTimeout(() => sync(), 150);

  }

}

  async function sync() {

    if (syncing) return;

    syncing = true;

    try {

      const cart = await getCart();

      const products = getProductItems(cart);
const delivery = getDeliveryItem(cart);

const allDeliveryItems = cart.items.filter(item =>
  Object.values(window.HRFurnitureShipping.variantIds).includes(item.variant_id)
);

// Keep only one delivery line
if (allDeliveryItems.length > 1) {

  for (let i = 1; i < allDeliveryItems.length; i++) {

    const line = cart.items.findIndex(
      x => x.key === allDeliveryItems[i].key
    ) + 1;

    if (line > 0) {
      await changeLine(line, 0);
    }

  }

  setTimeout(() => sync(), 300);
  return;
}

// Cart empty → remove delivery
if (!products.length) {

  if (delivery) {
    const line = cart.items.findIndex(i => i.key === delivery.key) + 1;
    if (line > 0) {
      await changeLine(line, 0);
    }
  }

  return;
}

// Delivery city product property se lo
const city =
  localStorage.getItem("hr_delivery_city") ||
  products[0].properties?.["Delivery City"] ||
  products[0].properties?.["Delivery city"] ||
  products[0].properties?.delivery_city ||
  "";

const requiredVariant = getDeliveryVariant(city);

if (!requiredVariant) return;



// Delivery item nahi hai → add karo
if (!delivery) {

 await addDelivery(requiredVariant, 1);

  return;
}

// Wrong delivery variant → replace
if (delivery.variant_id !== requiredVariant) {

  const line = cart.items.findIndex(i => i.key === delivery.key) + 1;

  await changeLine(line, 0);

  await addDelivery(requiredVariant, 1);

  return;
}
// Lock delivery line in cart
document.querySelectorAll(".cart-item").forEach(item => {

  const title = item.querySelector(".cart-item__name")?.textContent?.toLowerCase() || "";

  if (!title.includes("delivery")) return;

  item.querySelectorAll(".quantity").forEach(el => {
    el.style.display = "none";
  });

  item.querySelectorAll("cart-remove-button").forEach(el => {
    el.style.display = "none";
  });

});
// Quantity mismatch


console.log("HR Delivery Sync OK");

    }

    finally {

      syncing = false;

    }

  }

 window.HRDeliverySync = {
  sync
};

return window.HRDeliverySync;

})();
document.addEventListener("DOMContentLoaded", () => {

  HRDeliverySync.sync();

 document.addEventListener("cart:refresh", () => {

  setTimeout(() => HRDeliverySync.sync(), 300);

  setTimeout(() => HRDeliverySync.sync(), 800);

  setTimeout(() => HRDeliverySync.sync(), 1500);

});

  document.addEventListener("change", (e) => {

    if (
      e.target.matches("input[name='updates[]']") ||
      e.target.matches(".quantity__input")
    ) {
      setTimeout(() => HRDeliverySync.sync(), 500);
    }

  });

 

});